export const getProductPriceApiResponseMock = {
    getProductPrice: {
        maximum_price: {
            final_price: {
                currency: "EUR",
                value: 321.98,
            },
            regular_price: {
                currency: "EUR",
                value: 321.98,
            },
        },
        minimum_price: {
            final_price: {
                currency: "EUR",
                value: 321.98,
            },
            regular_price: {
                currency: "EUR",
                value: 321.98,
            },
        },
    },
};
//# sourceMappingURL=getProductPriceApiResponse.mock.js.map